// app-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Abrir manual em nova aba": "Abrir manual en una pestaña nueva",
    "Guias e tutoriais para utilizar as funcionalidades do painel": "Guías y tutoriales para utilizar las funcionalidades del panel",
    "Manual": "Manual",
    "Manual do Sistema": "Manual del Sistema",
    "PontuaX": "PontuaX",
    "PontuaX Logo": "Logo de PontuaX",
    "Página não encontrada": "Página no encontrada",
    "Voltar ao Manual": "Volver al Manual",
};

export default catalogo;
